import React, { useRef, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { device } from '../../../styles/device';
import { close } from '../assets/icons';

export const CandidatePageModal = ({
  handleExit,
  title,
  paragraph,
  show,
  width,
  removeOverFlowScroll,
  add,
  children,
}) => {
  const toggleClassName = show ? 'modal show' : 'modal';
  useEffect(() => {
    document.body.style.overflow = show ? 'hidden' : 'auto';
  }, [show]);

  const node = useRef();
  useEffect(() => {
    if (show) {
      document.addEventListener('mousedown', handleClick);
    } else {
      document.removeEventListener('mousedown', handleClick);
    }
  });

  const handleClick = (e) => {
    if (node.current === e.target || e.target.type === 'reset') {
      document.removeEventListener('mousedown', handleClick);
      document.body.style.overflow = 'auto';
      handleExit(false);
    }
    if (e.target.type === 'submit') {
      document.body.style.overflow = 'auto';
    }
    if (!node.current) document.removeEventListener('mousedown', handleClick);
  };

  return (
    <Overlay className={toggleClassName} ref={node}>
      <ModalContainer width={width} removeOverFlowScroll={removeOverFlowScroll}>
        <HeaderBox className='header-box'>
          <ModalButton
            role='button'
            onClick={() => {
              document.body.style.overflow = 'auto';
              handleExit(false);
            }}
          >
            <CloseIcon src={close} />
          </ModalButton>
        </HeaderBox>
        <ModalContent add={add}>
          {title && <Title>{title}</Title>}
          {paragraph && <Paragraph>{paragraph}</Paragraph>}
          {children}
        </ModalContent>
      </ModalContainer>
    </Overlay>
  );
};

const Overlay = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;
const ModalContainer = styled.div`
  width: ${(props) => (props.width ? ` ${props.width}` : ' 75% ')};
  max-height: 85%;
  border-radius: 0.5rem;
  overflow: ${(props) => (props.removeOverFlowScroll ? 'visible' : 'scroll')};
  background: #fff;
  box-shadow: 1rem 1rem 1.7rem -0.9rem rgba(0, 0, 0, 0.7);
  position: relative;
  @media ${device.mobileL} {
    width: 90%;
  }
`;
const ModalButton = styled.button`
  cursor: pointer;
  border-top-right-radius: 0.5rem;
  border: none;
  background-color: ${(props) => props.theme.color.white};
  position: absolute;
  top: 0;
  right: 0;
  padding-top: ${(props) => props.theme.spacing.standard};
  padding-right: ${(props) => props.theme.spacing.standard};
`;

const ModalContent = styled.div`
  padding: 0 6rem 4rem 6rem;
  @media ${device.mobileM} {
    padding: ${(props) => props.theme.spacing.standard};
  }
  ${(props) =>
    props.add &&
    css`
      height: 50rem;
      overflow-y: scroll;
    `}
`;

const CloseIcon = styled.img``;

const HeaderBox = styled.div`
  padding-top: ${(props) => props.theme.spacing.small};
  margin-bottom: ${(props) => props.theme.spacing.standard};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Title = styled.p`
  font-family: 'futura-pt', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 2.4rem;
  line-height: 3.8rem;
  text-align: center;
  letter-spacing: 0.01em;
  margin-bottom: 5rem;
`;

const Paragraph = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 2.2rem;
  line-height: 3.5rem;
  text-align: center;
  letter-spacing: 0.01em;
  margin-bottom: 5rem;
`;
